import * as premises from '@/constants/promises';

export default {
    data() {
        return {
            useNullablePremises: true,
        };
    },
    computed: {
        premisesTypeItems() {
            const items = [];
            if (this.useNullablePremises) {
                items.push({
                    text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
                    value: null,
                });
            }
            Object.keys(premises)
                .forEach((key) => {
                    if (key === 'OFFICE') {
                        items.push({
                            text: this.lang(this.$store, `sap/listings.global.filter.premises.${premises[key]}`),
                            value: premises[key],
                        });
                    }
                });
            return items;
        },
    },
};